import { makeStyles } from "@material-ui/core";
import { Search, TableChart } from "@material-ui/icons";
import { useQueryClient } from "@tanstack/react-query";
import { cardTitle } from "assets/jss/material-dashboard-pro-react";
import AnalysisModal from "components/Modals/AnalysisModal/AnalysisModal";
import Card from "components/UI/Card/Card";
import CardBody from "components/UI/Card/CardBody";
import CardHeader from "components/UI/Card/CardHeader";
import CardIcon from "components/UI/Card/CardIcon";
import ButtonTS from "components/Forms/CustomButtons/ButtonTS";
import GridItemTS from "components/UI/Grid/GridItemTS";
import ReactTable from "components/Tables/ReactTable/ReactTable";
import { format } from "date-fns";
import { useDisclosure } from "hooks/useDisclosure";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CellProps } from "react-table";
import {
  prefetchAnalysisByWorkItemID,
  useAnalysisByWorkItemID,
} from "services/input-core/analysis/get-analysis-by-work-item-id";
import { useWorkItems } from "services/input-core/work-items/get-work-items";
import { genarateBadgeFromBooleanStatus } from "utils/functions";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
};

const useStyles = makeStyles(styles as never);

function AnalysisTable() {
  const classes = useStyles();
  const queryClient = useQueryClient();
  const { t } = useTranslation("analysis");

  const { isOpen, onClose, onOpen } = useDisclosure();

  const { data: workItems } = useWorkItems();

  const [currentWorkItemId, setCurrentWorkItemId] = useState<string>(null);
  const { data: analysis } = useAnalysisByWorkItemID(currentWorkItemId);

  const columns = [
    {
      Header: t("source"),
      accessor: "profile",
    },
    {
      Header: t("source-id"),
      accessor: "requestParam",
    },
    {
      Header: t("activity"),
      accessor: "type",
    },
    {
      Header: t("status"),
      accessor: "result",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Cell: ({ row }: CellProps<any>) =>
        genarateBadgeFromBooleanStatus(row.original.approved, {
          translationFn: t,
        }),
    },
    {
      Header: t("date"),
      accessor: "updatedAt",
      sortDescFirst: true,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Cell: ({ row }: CellProps<any>) =>
        format(new Date(row.original.updatedAt), "dd/MM/yyyy HH:mm"),
    },
    {
      Header: t("actions"),
      accessor: "actions",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Cell: ({ row }: CellProps<any>) => (
        <div className="actions-right">
          <ButtonTS
            justIcon
            round
            size="sm"
            color="success"
            onClick={() => {
              setCurrentWorkItemId(row.original.id);
              onOpen();
            }}
            onMouseEnter={() => {
              prefetchAnalysisByWorkItemID(row.original.id, queryClient);
            }}
            className="edit"
          >
            <TableChart />
          </ButtonTS>
        </div>
      ),
    },
  ];
  return (
    <>
      <GridItemTS xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Search />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>{t("analysis")}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable columns={columns} data={workItems || []} />
          </CardBody>
        </Card>
      </GridItemTS>

      <AnalysisModal
        modal={isOpen}
        handleClose={onClose}
        analysis={analysis || []}
      />
    </>
  );
}

export default AnalysisTable;
